import { useNavigate, useLocation, type NavigateOptions } from 'react-router-dom';

const useNavigateWithParams = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  const navigateWithParams = (pathname: string, options?: NavigateOptions) => {
    navigate({ pathname, search }, options || {});
  };

  return navigateWithParams;
};

export default useNavigateWithParams;
